module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-3.24072f4a.svg";